module.exports = __webpack_public_path__ + "static/the-value-of-everything-111ef7f56ef326afb0ffc5c800626f47.jpg";